import { render } from "./PageMessage.vue?vue&type=template&id=07ed8e6d"
import script from "./PageMessage.vue?vue&type=script&lang=js"
export * from "./PageMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__